import apiClient from './apiClient';

/**
 * API service for customer management.
 */
export const customerApi = {
    /**
     * Fetch all customers for the current company.
     * @returns {Promise<Array>} List of customers
     */
    getAll: async () => {
        const response = await apiClient.get('/api/customers');
        return response.data;
    },

    /**
     * Fetch a single customer by ID.
     * @param {string} id - Customer UUID
     * @returns {Promise<Object>} Customer data
     */
    getById: async (id) => {
        const response = await apiClient.get(`/api/customers/${id}`);
        return response.data;
    },

    /**
     * Create a new customer.
     * @param {Object} customerData - Customer details
     * @returns {Promise<Object>} Created customer
     */
    create: async (customerData) => {
        const response = await apiClient.post('/api/customers', customerData);
        return response.data;
    },

    /**
     * Update an existing customer.
     * @param {string} id - Customer UUID
     * @param {Object} customerData - Updated details
     * @returns {Promise<Object>} Updated customer
     */
    update: async (id, customerData) => {
        const response = await apiClient.put(`/api/customers/${id}`, customerData);
        return response.data;
    },

    /**
     * Delete a customer.
     * @param {string} id - Customer UUID
     * @returns {Promise<Object>} Deletion result
     */
    delete: async (id) => {
        const response = await apiClient.delete(`/api/customers/${id}`);
        return response.data;
    },

    /**
     * Bulk update status for multiple customers.
     * @param {Array<string>} ids - List of customer UUIDs
     * @param {string} status - New status
     * @returns {Promise<Object>} Result message
     */
    bulkUpdateStatus: async (ids, status) => {
        const response = await apiClient.put('/api/customers/bulk-status', { ids, status });
        return response.data;
    },

    /**
     * Bulk delete multiple customers.
     * @param {Array<string>} ids - List of customer UUIDs
     * @returns {Promise<Object>} Result message
     */
    bulkDelete: async (ids) => {
        const response = await apiClient.delete('/api/customers/bulk-delete', { data: { ids } });
        return response.data;
    }
};
